module.exports = __webpack_public_path__ + "img/bar.bdef7966.png";